const faqs = [
  {
    q: '刃牙漫画观看顺序是怎样的？',
    a: '推荐按出版顺序阅读：刃牙第一部（地下斗技场篇）→ 刃牙II（最凶死刑犯篇、中国大擂台篇）→ 范马刃牙（皮可篇、父子决战篇）→ 刃牙道（宫本武藏篇）→ 刃牙道II（相扑道篇，当前连载中）。外传系列可在主线阅读间隙阅读。',
  },
  {
    q: '刃牙漫画多久更新一次？',
    a: '刃牙漫画目前以周刊形式连载，刃牙道II（相扑道篇）每周更新一话。平台同步更新，确保读者第一时间获取刃牙漫画最新章节。遇到日本节假日或作者休刊时会有短暂延迟。',
  },
  {
    q: '刃牙漫画完整版包含哪些内容？',
    a: '刃牙漫画完整版包含从第一部到最新连载的全部章节，覆盖地下斗技场篇、死刑犯篇、中国大擂台篇、皮可篇、父子决战篇、武藏篇以及当前连载的相扑道篇。另外还包括花山薰外传等衍生作品。',
  },
  {
    q: '可以在手机上刃牙漫画在线看吗？',
    a: '当然可以！平台支持刃牙漫画在线看，手机、平板、电脑均可流畅阅读。采用下拉式设计，无需翻页等待，自动适配不同屏幕尺寸，带来沉浸式阅读体验。',
  },
  {
    q: '刃牙漫画大全是否免费？',
    a: '本站刃牙漫画合集内容均供学习交流使用。目前平台所有内容均可免费阅读，注册账号后可享受收藏、历史记录等更多功能。',
  },
  {
    q: '刃牙动画和漫画有什么区别？',
    a: '刃牙漫画是板垣惠介老师的原作，内容最为完整。动画版进行了部分改编和删减，战斗场景视觉冲击力更强但部分情节有所调整。推荐漫画动画结合观看，先读原作了解完整剧情，再看动画感受动态战斗。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          关于刃牙漫画阅读的常见疑问，这里都有答案
        </p>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0">Q{i + 1}.</span>
                <span>{item.q}</span>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}